import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { baseURLs } from 'utils/baseURLs';
import moodleAxios from '../../../services/moodle/moodleApi';

const arr = [];

export const fetchCoursesAsync = createAsyncThunk('courses/fetchCoursesAsync', async () => {
  const res = await moodleAxios.get(baseURLs.core_course_get_categories);
  res.data.map(cr => {
    if (cr.parent === 0) {
      let temp = { ...cr, items: [] };
      arr.push(temp);
    }
  });
  res.data.map(cr => {
    cr = { ...cr, link: `/courses/${cr.name}` };
    let find = arr.filter(x => x.id === cr.parent)[0];
    if (find) {
      find.items.push(cr);
    }
  });
  arr.map(doc => {
    if (doc.items.length === 0) {
      doc.link = `/courses/${doc.name}`;
    }
  });
  const res1 = await moodleAxios.get(baseURLs.core_course_get_courses_by_field + `2`);
  let t = {
    ...res1.data.courses[0],
    items: [],
    link: `/courses/${res1.data.courses[0].shortname}`
  };
  arr.push(t);
  return [];
});

export const fetchCoursesByIdAsync = createAsyncThunk('courses/fetchCoursesByIdAsync', async id => {
  const res = await moodleAxios.get(baseURLs.core_course_get_courses_by_field + id);
  return res.data;
});

const courseSlice = createSlice({
  name: 'courses',
  initialState: {
    courses: {},
    load: false,
    error: false
  },
  reducers: {
    addCourses: (state, { payload }) => {
      state.courses = payload;
      state.load = false;
    }
  },

  extraReducers: {
    [fetchCoursesAsync.pending]: state => {
      state.load = true;
    },
    [fetchCoursesAsync.fulfilled]: (state, { payload }) => {
      state.courses = payload;
      state.load = false;
    },
    [fetchCoursesAsync.rejected]: (state, { payload }) => {
      state.error = payload;
      state.load = false;
    }
  }
});
export const getCourseAsync = state => state.courses.courses;
export default courseSlice.reducer;
